/**
 * Local Bridge API feature flag and config.
 * Extracted to avoid circular dependency between productDomainSessionApi and bridgeSessionDataAdapter.
 */
import { LOCAL_BRIDGE_API_URL } from '../config';
import { localBridgeApiClient } from './localBridgeApiClient';

export function isLocalBridgeApiEnabled(): boolean {
  return Boolean(LOCAL_BRIDGE_API_URL && localBridgeApiClient);
}
